import * as Bixby from '$/core';
import { LoginClearPreloadedData } from '../login/types';

export interface DraftState {
  isLoading: boolean;
  error?: Bixby.Models.BixbyError;
  draftCompany?: Bixby.Models.DraftCompany;
  isEditing: boolean;
  discardDraft?: boolean;
}

export const DRAFT_LOADING = 'DRAFT_LOADING';
export const DRAFT_SUCCESS = 'DRAFT_SUCCESS';
export const DRAFT_FAILURE = 'DRAFT_FAILURE';
export const SET_DRAFT_COMPANY = 'SET_DRAFT_COMPANY';
export const UPDATE_DRAFT_INPROGRESS = 'UPDATE_DRAFT_INPROGRESS';
export const UPDATE_DRAFT_SUCCESS = 'UPDATE_DRAFT_SUCCESS';
export const UPDATE_DRAFT_FAILURE = 'UPDATE_DRAFT_FAILURE';
export const CREATE_DRAFT_INPROGRESS = 'CREATE_DRAFT_INPROGRESS';
export const CREATE_DRAFT_SUCCESS = 'CREATE_DRAFT_SUCCESS';
export const CREATE_DRAFT_FAILURE = 'CREATE_DRAFT_FAILURE';
export const DELETE_DRAFT_INPROGRESS = 'DELETE_DRAFT_INPROGRESS';
export const DELETE_DRAFT_SUCCESS = 'DELETE_DRAFT_SUCCESS';
export const DELETE_DRAFT_FAILURE = 'DELETE_DRAFT_FAILURE';
export const PUBLISH_DRAFT_INPROGRESS = 'PUBLISH_DRAFT_INPROGRESS';
export const PUBLISH_DRAFT_SUCCESS = 'PUBLISH_DRAFT_SUCCESS';
export const PUBLISH_DRAFT_FAILURE = 'PUBLISH_DRAFT_FAILURE';
export const SET_DRAFT_INPROGRESS = 'SET_DRAFT_INPROGRESS';
export const SET_DISCARD_DRAFT = 'SET_DISCARD_DRAFT';

interface DraftLoading extends Bixby.Models.BixbyAction<undefined, typeof DRAFT_LOADING> {
  type: typeof DRAFT_LOADING;
}

interface DraftSuccess extends Bixby.Models.BixbyAction<Bixby.Models.DraftCompany, typeof DRAFT_SUCCESS> {
  type: typeof DRAFT_SUCCESS;
  payload: Bixby.Models.DraftCompany;
}

interface DraftFailure extends Bixby.Models.BixbyAction<Bixby.Models.BixbyError, typeof DRAFT_FAILURE> {
  type: typeof DRAFT_FAILURE;
  payload: Bixby.Models.BixbyError;
}

interface UpdateDraftInProgress extends Bixby.Models.BixbyAction<undefined, typeof UPDATE_DRAFT_INPROGRESS> {
  type: typeof UPDATE_DRAFT_INPROGRESS;
}

interface UpdateDraftSuccess extends Bixby.Models.BixbyAction<undefined, typeof UPDATE_DRAFT_SUCCESS> {
  type: typeof UPDATE_DRAFT_SUCCESS;
}

interface UpdateDraftFailure extends Bixby.Models.BixbyAction<Bixby.Models.BixbyError, typeof UPDATE_DRAFT_FAILURE> {
  type: typeof UPDATE_DRAFT_FAILURE;
  payload: Bixby.Models.BixbyError;
}

interface CreateDraftInProgress extends Bixby.Models.BixbyAction<undefined, typeof CREATE_DRAFT_INPROGRESS> {
  type: typeof CREATE_DRAFT_INPROGRESS;
}

interface CreateDraftSuccess extends Bixby.Models.BixbyAction<undefined, typeof CREATE_DRAFT_SUCCESS> {
  type: typeof CREATE_DRAFT_SUCCESS;
}

interface CreateDraftFailure extends Bixby.Models.BixbyAction<Bixby.Models.BixbyError, typeof CREATE_DRAFT_FAILURE> {
  type: typeof CREATE_DRAFT_FAILURE;
  payload: Bixby.Models.BixbyError;
}

interface SetDraftCompany extends Bixby.Models.BixbyAction<Bixby.Models.DraftCompany, typeof SET_DRAFT_COMPANY> {
  type: typeof SET_DRAFT_COMPANY;
  payload: Bixby.Models.DraftCompany;
}

interface DeleteDraftInProgress extends Bixby.Models.BixbyAction<undefined, typeof DELETE_DRAFT_INPROGRESS> {
  type: typeof DELETE_DRAFT_INPROGRESS;
}

interface DeleteDraftSuccess extends Bixby.Models.BixbyAction<undefined, typeof DELETE_DRAFT_SUCCESS> {
  type: typeof DELETE_DRAFT_SUCCESS;
}

interface DeleteDraftFailure extends Bixby.Models.BixbyAction<Bixby.Models.BixbyError, typeof DELETE_DRAFT_FAILURE> {
  type: typeof DELETE_DRAFT_FAILURE;
  payload: Bixby.Models.BixbyError;
}

interface PublishDraftInProgress extends Bixby.Models.BixbyAction<undefined, typeof PUBLISH_DRAFT_INPROGRESS> {
  type: typeof PUBLISH_DRAFT_INPROGRESS;
}

interface PublishDraftSuccess extends Bixby.Models.BixbyAction<undefined, typeof PUBLISH_DRAFT_SUCCESS> {
  type: typeof PUBLISH_DRAFT_SUCCESS;
}

interface PublishDraftFailure extends Bixby.Models.BixbyAction<Bixby.Models.BixbyError, typeof PUBLISH_DRAFT_FAILURE> {
  type: typeof PUBLISH_DRAFT_FAILURE;
  payload: Bixby.Models.BixbyError;
}

interface SetDraftInProgress extends Bixby.Models.BixbyAction<boolean, typeof SET_DRAFT_INPROGRESS> {
  type: typeof SET_DRAFT_INPROGRESS;
  payload: boolean;
}

interface SetDiscardDraft extends Bixby.Models.BixbyAction<boolean, typeof SET_DISCARD_DRAFT> {
  type: typeof SET_DISCARD_DRAFT;
  payload: boolean;
}

export type DraftActionTypes =
  | DraftLoading
  | DraftSuccess
  | DraftFailure
  | UpdateDraftInProgress
  | UpdateDraftSuccess
  | UpdateDraftFailure
  | CreateDraftInProgress
  | CreateDraftSuccess
  | CreateDraftFailure
  | SetDraftCompany
  | DeleteDraftInProgress
  | DeleteDraftSuccess
  | DeleteDraftFailure
  | PublishDraftInProgress
  | PublishDraftFailure
  | PublishDraftSuccess
  | SetDraftInProgress
  | SetDiscardDraft
  | LoginClearPreloadedData;
